import type { Traducao } from '../tipos';

/** Textos de `projetos`. Preenchido pela tradução da área — ver ../README.md. */
export const projetos: Traducao = {
  pt: {
    squads: {
      titulo: 'Selecione um Squad',
      subtitulo: 'Escolha o squad para ver os projetos da região',
      semSquad: 'Sem squad',
      contagemProjetos: '{{total}} projeto(s)',
      vazio: 'Nenhum squad cadastrado. Cadastre em Squads no menu.',
    },
    lista: {
      voltarSquads: 'Voltar para squads',
      titulo: 'Selecione um Projeto',
      tituloSquad: 'Projetos — {{squad}}',
      subtitulo: 'Escolha um projeto para continuar',
      subtituloAdmin: 'Escolha um projeto para continuar ou crie um novo',
      criarNovo: 'Criar Novo Projeto',
      vazio: 'Nenhum projeto disponível no momento.',
      vazioAdmin: 'Nenhum projeto neste squad. Crie um novo projeto para começar.',
      criarPrimeiro: 'Criar Primeiro Projeto',
    },
    card: {
      badgeBudget: 'Controle de Budget',
      badgeManual: 'Manual de Operação',
      badgeModelo: 'Modelo: {{modelo}}',
      badgeBudgetCurto: 'Budget',
      badgeAtual: 'Projeto atual',
      contadorApreciacoes: '{{total}} apreciações',
      contadorTemplates: '{{total}} templates',
      contadorAtivos: '{{total}} ativos',
      moverCima: 'Mover para cima',
      moverBaixo: 'Mover para baixo',
      editar: 'Editar projeto',
    },
    form: {
      nome: 'Nome do Projeto *',
      nomePlaceholder: 'Digite o nome do projeto',
      descricao: 'Descrição (opcional)',
      descricaoPlaceholder: 'Digite a descrição do projeto',
      tipoProjeto: 'Tipo de projeto',
      tipoPadrao: 'Padrão (apreciações, máquinas...)',
      tipoBudget: 'Controle de Budget',
      tipoManual: 'Manual de Operação',
      ajudaBudget: 'Projeto apenas de controle financeiro — sem dashboard, apreciações etc.',
      ajudaManualCriar: 'Workspace editorial dedicado, sem menu lateral, para criar o manual reconstituído.',
      ajudaManualEditar: 'Projeto editorial dedicado, aberto sem menu lateral.',
      modeloDocumento: 'Modelo do documento',
      modeloNenhum: 'Nenhum (definir depois)',
      squad: 'Squad',
      squadNenhum: 'Nenhum (visível a todos)',
      budgetHabilitar: 'Habilitar controle de budget',
      budgetTotal: 'Budget total (R$)',
      budgetTotalPlaceholder: '0,00',
    },
    criar: {
      titulo: 'Criar Novo Projeto',
      squadDestino: 'O projeto será criado no squad {{squad}}.',
      criando: 'Criando...',
    },
    editar: {
      titulo: 'Editar Projeto',
    },
  },
  en: {
    squads: {
      titulo: 'Select a Squad',
      subtitulo: 'Choose the squad to see the projects for that region',
      semSquad: 'No squad',
      contagemProjetos: '{{total}} project(s)',
      vazio: 'No squads registered. Add one under Squads in the menu.',
    },
    lista: {
      voltarSquads: 'Back to squads',
      titulo: 'Select a Project',
      tituloSquad: 'Projects — {{squad}}',
      subtitulo: 'Choose a project to continue',
      subtituloAdmin: 'Choose a project to continue or create a new one',
      criarNovo: 'Create New Project',
      vazio: 'No projects available at the moment.',
      vazioAdmin: 'No projects in this squad. Create a new project to get started.',
      criarPrimeiro: 'Create First Project',
    },
    card: {
      badgeBudget: 'Budget Control',
      badgeManual: 'Operation Manual',
      badgeModelo: 'Model: {{modelo}}',
      badgeBudgetCurto: 'Budget',
      badgeAtual: 'Current project',
      contadorApreciacoes: '{{total}} risk assessments',
      contadorTemplates: '{{total}} templates',
      contadorAtivos: '{{total}} assets',
      moverCima: 'Move up',
      moverBaixo: 'Move down',
      editar: 'Edit project',
    },
    form: {
      nome: 'Project Name *',
      nomePlaceholder: 'Enter the project name',
      descricao: 'Description (optional)',
      descricaoPlaceholder: 'Enter the project description',
      tipoProjeto: 'Project type',
      tipoPadrao: 'Standard (risk assessments, machines...)',
      tipoBudget: 'Budget Control',
      tipoManual: 'Operation Manual',
      ajudaBudget: 'Financial control only — no dashboard, risk assessments, etc.',
      ajudaManualCriar: 'Dedicated editorial workspace, without the side menu, to build the reconstructed manual.',
      ajudaManualEditar: 'Dedicated editorial project, opened without the side menu.',
      modeloDocumento: 'Document model',
      modeloNenhum: 'None (set later)',
      squad: 'Squad',
      squadNenhum: 'None (visible to everyone)',
      budgetHabilitar: 'Enable budget control',
      budgetTotal: 'Total budget (R$)',
      budgetTotalPlaceholder: '0.00',
    },
    criar: {
      titulo: 'Create New Project',
      squadDestino: 'The project will be created in the {{squad}} squad.',
      criando: 'Creating...',
    },
    editar: {
      titulo: 'Edit Project',
    },
  },
};
